$(document).ready(function () {
  function setupFooterAccordion() {
    if ($(window).width() <= 991) {
      $('footer.clFooter .menuBox h3').off('click').on('click', function () {
        var $thisMenuBox = $(this).closest('.menuBox');
        var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
        var $thisSvg = $(this).find('svg');
        $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
        $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
        $thisLinks.stop(true, true).slideToggle();
        $thisSvg.toggleClass('rotated');
      });
    } else {
      // Desktop: Show all and unbind click
      $('footer.clFooter .menuBox .menuBoxLinks').show();
      $('footer.clFooter .menuBox h3').off('click');
      $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
    }
  }
  setupFooterAccordion();
  $(window).resize(setupFooterAccordion);
});
// Popup Open

$('.clBtnDrawer').on('click', function() {
  $('#cl-popup--drawer').addClass('active');
});